import * as React from 'react'

import * as classnames from 'classnames'
import * as styles from './documentOverlay.css'

import posed from 'react-pose'

import { StoreComponent, injectStores } from '../../../../store'
import { observer } from 'mobx-react'

import enhanceWithClickOutside from 'react-click-outside'
import { CloseButtonBlack, CloseButtonMobile } from '../../../common/elements/buttons'
import { Portal } from 'react-portal'
import { observable } from 'mobx'
import { Drawer } from '../../drawer/drawer'
import { bind } from 'bind-decorator'

const overlayProps = {
  open: { x: '0%', transition: { duration: 500, ease: 'easeOut' } },
  closed: { x: '0%', transition: { duration: 500, ease: 'easeIn' } }
}

const Sidebar = posed.div(overlayProps)

interface IProps {
  onCloseClick: () => void
  content: any
  open: boolean
}

@injectStores
@enhanceWithClickOutside
@observer
export class DocumentOverlay extends StoreComponent<IProps> {
  @observable right = 0

  element: HTMLDivElement | null = null

  componentDidMount () {
    this.setRight()
  }

  componentDidUpdate () {
    this.setRight()
  }

  handleClickOutside () {
    this.props.onCloseClick()
  }

  @bind
  setRight () {
    if (this.element && this.store.breakpoints.desktop) {
      const rect = this.element.getBoundingClientRect()
      this.right = rect.right - rect.left
    } else {
      this.right = 0
    }
  }

  render () {
    let closeButton: JSX.Element | null = null
    closeButton = <Portal>
                    <div className={ styles.closeButton } style={ { right: `${this.right}px` } }>
                      {this.store.breakpoints.desktop ? <CloseButtonBlack onClick={ this.props.onCloseClick }/> : <CloseButtonMobile onClick={ this.props.onCloseClick }/> }
                    </div>
                  </Portal>

    let content: JSX.Element | null = null
    let quelle: JSX.Element | null = null
    if (!this.props.content.urlHeaderImage) {
      let text = this.props.content.textHtml.replace(/\s/g, ' ')
      let quelleText = this.props.content.headerImageSource.replace(/\.\s/g,'\.\u00a0').replace(/-/g,'\u2060-\u2060')
      if (this.props.content.title === 'Konrad Adenauers Brief an Heinrich Krone') {
        quelleText = quelleText.replace(/1959\,\sS/g, '1959\,\u00a0S')
      }

      quelle = <div className={ styles.quelle }>{ quelleText }</div>

      content = <div className={ styles.textContent }>
                  <div className={ styles.top }>
                    <div className={ styles.caption }>{ this.props.content.title }</div>
                    { this.store.breakpoints.desktop && quelle }
                  </div>
                  <div className={ styles.text } dangerouslySetInnerHTML={ { __html: text } }></div>
                  { this.store.breakpoints.phone && quelle }
                </div>
    }

    return (
        <Sidebar pose={ 'closed'} key='document-overlay' className={ classnames(styles.docOverlay, 'document-overlay') } style={ this.props.content.subcontentType === 'Picture' && this.store.breakpoints.phone ? { backgroundColor: 'rgba(0, 0, 0, 0)' } : undefined}>
          { closeButton }
          { this.props.content.subcontentType === 'Picture' && <Drawer data={ this.props.content }/>}
          <div className={ styles.headerImage } ref={ elem => this.element = elem }>
            <img src={ this.props.content.urlHeaderImage } alt={ this.props.content.urlHeaderImage && 'document-image' } />
          </div>
          { content }
        </Sidebar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/book/overlays/documentOverlay.tsx